import { GenericRTEModalProps } from './GenericRTEModal';
import { openModal } from '@core/components/ModalStack';

export async function openGenericRTEModal(props: GenericRTEModalProps) {
  const { GenericRTEModal } = await import('./GenericRTEModal');

  openModal(GenericRTEModal, props);
}
